// extracted by mini-css-extract-plugin
export var divider = "_e8-7";
export var itemsToggle = "_e8-8";
export var mergeModal = "_e8-1";
export var optionCard = "_e8-4";
export var radioGroup = "_e8-6";
export var radioOption = "_e8-0";
export var selected = "_e8-5";
export var shipmentOptions = "_e8-2";
export var tableOptions = "_e8-3";